module.exports = __webpack_public_path__ + "static/media/Pizza.ffa1a2a2.png";